import { type } from "../../types/types";

export default function reducer(state = { store: {} }, action) {
  switch (action.type) {
    case type.SET_STORE:
      return { ...state, ...action.store };
    default:
      return state;
  }
}
